import * as React from "react"
import { Skeleton } from "@mui/material"

import { TitleWithPopover, AppTableSeeker } from "@components"
import { WEBBACK_V2_API } from "@constants"
import { useToast, useUserApp } from "@hooks"
import { isLoadingCommonFilters } from "@signals"
import {
    daysOutStockColumn,
    daysStockColumn,
    firstSeenColumn,
    lastDayStockColumn,
    lastOutStockColumn,
    lastSeenColumn,
    skuColumn,
    retailerColumn,
    stockStatusColumn,
	numVariantsColumn
} from "./columns"
import { useStockAssDetailsTableDetails } from "../@hooks"
import CreateReportButton from "./actions/CreateReportButton"


const HEIGHT = 500

export default function StockAssortmentDetailsTable() {

	const { tableData, isLoading } = useStockAssDetailsTableDetails()
	const { showToast } = useToast()
	const { userGroupByProductID } = useUserApp()

	if (isLoading || isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={HEIGHT} />
	if (!tableData.length) return <></>

	return <AppTableSeeker
		title={<TitleWithPopover title="Stock & Assortment - Details" />}
		data={tableData}
		columns={[
			...retailerColumn(),
			...skuColumn(),
			...firstSeenColumn(),
			...lastSeenColumn(),
			...stockStatusColumn(),
			...!userGroupByProductID ? [numVariantsColumn()] : [],
			lastDayStockColumn(),
			daysStockColumn(),
			lastOutStockColumn(),
			daysOutStockColumn()
		]}
		options={{
			onDownload: () => showToast.promiseExcel(`${WEBBACK_V2_API}/stock-assortment/details/table-excel`),
			rowsPerPageOptions: [5, 10],
            customToolbar: () => <CreateReportButton />
		}}
	/>
}